



























import { Component, Prop, Vue } from 'vue-property-decorator';
import Dropdown, { DropdownOption } from '../dropdown/Dropdown.vue';
import Icon from '../Icon.vue';

@Component({
  components: { Dropdown, Icon },
})
export default class FilterDropdownItem extends Vue {
  @Prop({ default: 'filter' })
  title: string;

  @Prop({ required: true })
  name: string;

  @Prop({ default: false })
  isMultiSelect: boolean;

  @Prop({ required: true })
  dropdownOptions: DropdownOption[];

  @Prop({ required: true })
  onOptionSubmit: (
    name: string,
    selectedOption: DropdownOption,
  ) => Promise<void>;

  async onOptionClicked(selectedOption: DropdownOption) {
    this.onOptionSubmit(this.name, selectedOption);
  }
}
